import { useEffect, useState } from "react";
import axios from "axios";
import { FinanceData } from "../types/FinanceData";

export enum Status {
  Loading,
  Error,
  Success,
}

export const FetchData = (token: string | null) => {
  const [data, setdata] = useState<FinanceData | null>(null);
  const [status, setStatus] = useState<Status>(Status.Loading);

  useEffect(() => {
    if (!token) {
      return;
    }

    setStatus(Status.Loading);

    async function callEndpoint() {
      try {
        const response = await axios.get<FinanceData>("https://api.saneetbhella.co.uk/finance/data", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdata(response.data);
        setStatus(Status.Success);
      } catch (err: any) {
        console.error(err);
        setStatus(Status.Error);
      }
    }
    callEndpoint();
  }, [token]);

  return { data, status };
};
